import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('close', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: props.colors[0],
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: "0",
    x: "0",
    y: "0",
    width: "128",
    height: "128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9226288,62.9949118 L110.558049,103.620534 C112.473791,105.536276 112.473791,108.642307 110.558049,110.558049 C108.642307,112.473791 105.536276,112.473791 103.620534,110.558049 L62.9949118,69.9226288 L22.36929,110.558049 C20.4535479,112.473791 17.3475163,112.473791 15.4317743,110.558049 C13.5160322,108.642307 13.5160322,105.536276 15.4317743,103.620534 L56.0671948,62.9949118 L15.4317743,22.36929 C14.1925064,21.1300222 13.7085172,19.32375 14.1621207,17.6308786 C14.6157242,15.9380073 15.9380073,14.6157242 17.6308786,14.1621207 C19.32375,13.7085172 21.1300222,14.1925064 22.36929,15.4317743 L62.9949118,56.0671948 L103.620534,15.4317743 C105.536276,13.5160322 108.642307,13.5160322 110.558049,15.4317743 C112.473791,17.3475163 112.473791,20.4535479 110.558049,22.36929 L69.9226288,62.9949118 Z"
  }))));
});